import FlopyModflowPackage from './FlopyModflowPackage';

export default abstract class FlopyModflowBoundary<T> extends FlopyModflowPackage<T> {
}
